/**
 * @generated SignedSource<<9c94d71caf66f0d8c14640d52739755a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type MeetingsPanelEventQuery$variables = {
  eventGuid?: string | null;
};
export type MeetingsPanelEventQuery$data = {
  readonly event: {
    readonly id: string;
    readonly start: string | null;
  } | null;
};
export type MeetingsPanelEventQuery = {
  response: MeetingsPanelEventQuery$data;
  variables: MeetingsPanelEventQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "eventGuid"
  }
],
v1 = [
  {
    "alias": "event",
    "args": [
      {
        "kind": "Variable",
        "name": "guid",
        "variableName": "eventGuid"
      }
    ],
    "concreteType": "Event",
    "kind": "LinkedField",
    "name": "eventByGuid",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "start",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MeetingsPanelEventQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MeetingsPanelEventQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "85c1c610afdb148fac192e178a6a7794",
    "id": null,
    "metadata": {},
    "name": "MeetingsPanelEventQuery",
    "operationKind": "query",
    "text": "query MeetingsPanelEventQuery(\n  $eventGuid: String\n) {\n  event: eventByGuid(guid: $eventGuid) {\n    id\n    start\n  }\n}\n"
  }
};
})();

(node as any).hash = "75e97eb86895560dc270841c3589bdd4";

export default node;
